import { getToken } from '../utils/jwt-helper';

/**
 * Build-time env (CRA): set in Railway UI or .env for production.
 * Defaults preserve current production URLs so behavior stays the same if unset.
 */
const trimSlash = (s) => String(s || '').replace(/\/$/, '');

/** Set REACT_APP_BUILD_STAMP in Railway when you deploy so DevTools logs prove which bundle is running. */
export const BUILD_STAMP =
  process.env.REACT_APP_BUILD_STAMP || (process.env.NODE_ENV === 'production' ? 'prod' : 'dev');

// Railway: use REACT_APP_API_BASE_URL (preferred). REACT_APP_API_URL is accepted as alias — many dashboards typo the name.
export const API_BASE_URL = trimSlash(
  process.env.REACT_APP_API_BASE_URL ||
    process.env.REACT_APP_API_URL ||
    'https://backend-production-6b47.up.railway.app'
);

/** Pull zone / CDN hostname for product images (Bunny CDN) */
export const CDN_BASE_URL = trimSlash(
  process.env.REACT_APP_CDN_URL || 'https://pinksislypz2.b-cdn.net'
);

/** react-admin data provider base (same API host + /api) */
export const ADMIN_API_BASE_URL = `${API_BASE_URL}/api`;

export const API_URLS = {
  GET_PRODUCTS: '/api/products',
  GET_PRODUCT: (id) => `/api/product/${id}`,
  GET_CATEGORIES: '/api/category',
  GET_CATEGORY: (id) => `/api/category/${id}`,
};

/** Thrown when a protected request is built without a JWT (caller should not hit the API). */
export class AuthenticationRequiredError extends Error {
  constructor() {
    super('AUTH_REQUIRED');
    this.name = 'AuthenticationRequiredError';
  }
}

function requireTrimmedToken() {
  const token = getToken();
  const t = token != null ? String(token).trim() : '';
  if (!t) {
    throw new AuthenticationRequiredError();
  }
  return t;
}

/**
 * Optional Bearer — use only for endpoints that allow anonymous access but may attach a JWT when present
 * (e.g. file upload while logged in).
 */
export const getOptionalBearerHeaders = () => {
  const token = getToken();
  const t = token != null ? String(token).trim() : '';
  return t ? { Authorization: `Bearer ${t}` } : {};
};

/** Protected REST calls: always includes Authorization; throws if there is no JWT. */
export const getBearerHeaders = () => {
  const t = requireTrimmedToken();
  return { Authorization: `Bearer ${t}` };
};

/** Protected JSON POST/PUT/PATCH: Content-Type + Authorization; throws if there is no JWT. */
export const getBearerJsonHeaders = () => {
  const t = requireTrimmedToken();
  return {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: `Bearer ${t}`,
  };
};
